/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationLaborTimeItem } from '@1po/1po-bff-fe-spec/generated/catalog/easy_basket/response/GetEasyBasketOperationDetailResponse';
import LaborTimesSelectionGroup from 'pages/CatalogPage/DH/SubcategorySection/OperationsSection/LaborTimesSelection/LaborTimesSelectionGroup';
import { Flex } from 'UI';
import { useSortLaborTimeGroups, useGlobalMainGOLaborTimeId } from '../utils';

const LaborTimesSelectionGroups = ({ laborTimesGroups }: { laborTimesGroups: OperationLaborTimeItem[] }) => {
  const { t } = useTranslation();
  const sortedGroups = useSortLaborTimeGroups(laborTimesGroups);
  const mainGOId = useGlobalMainGOLaborTimeId(sortedGroups);
  return (
    <Flex direction={'column'} gap={15}>
      <Flex minHeight={50} padding={'0 15px 0 60px'} align={'center'} gap={7} justify={'space-between'}>
        <Flex>Code</Flex>
        <Flex justify={'center'}>{t('catalog.easy_basket.labor_times.header.type', 'Type')}</Flex>
        <Flex justify={'center'}>{t('catalog.easy_basket.labor_times.header.time', 'Time')}</Flex>
        <Flex justify={'center'}>{t('catalog.easy_basket.labor_times.header.quantity', 'Quantity')}</Flex>
        <Flex justify={'center'} minWidth={250}>
          {t('catalog.easy_basket.labor_times.header.details', 'Details')}
        </Flex>
        <Flex justify={'center'}>{t('catalog.easy_basket.labor_times.header.rate', 'Rate')}</Flex>
        <Flex maxWidth={100} />
      </Flex>
      {sortedGroups.map((laborTimeGroup) => (
        <LaborTimesSelectionGroup key={laborTimeGroup.itemGroup} laborTimeGroup={laborTimeGroup} mainGOId={mainGOId} />
      ))}
    </Flex>
  );
};

export default LaborTimesSelectionGroups;
